export class Equipment {
  public id;
  public equipmentModel;
  public serial;
  public imei;
  public price;
  public aquisitionDate;
  public expirationDate;
  public customer;
  public branch;
  public autoEletric;
  public simCard;
  public histories;
  public sentCommands;
  public equipmentStatus;
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/equipment.ts